export const SET_WAYPOINT = "SET_WAYPOINT";

export function setWaypoint(payload) {
  return {
    type: SET_WAYPOINT,
    payload: {
      isAboveWaypoint: payload,
    },
  };
}
